// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_exchange_title = /** @type {(inputs: {}) => string} */ () => {
	return `Exchanges`
};

const el_refunds_exchange_title = /** @type {(inputs: {}) => string} */ () => {
	return `Αντικαταστάσεις`
};

const ru_refunds_exchange_title = /** @type {(inputs: {}) => string} */ () => {
	return `Обмен`
};

const he_refunds_exchange_title = /** @type {(inputs: {}) => string} */ () => {
	return `החלפות`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_exchange_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_exchange_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_exchange_title", locale)
	if (locale === "en") return en_refunds_exchange_title(inputs)
	if (locale === "el") return el_refunds_exchange_title(inputs)
	if (locale === "ru") return ru_refunds_exchange_title(inputs)
	if (locale === "he") return he_refunds_exchange_title(inputs)
	return "refunds_exchange_title"
};